import { ModeOption } from '../../../core';
import { OptionsEditorControl } from '../OptionsEditorLayout';
import { SettingsAutocomplete } from '../SettingsAutocomplete';

const MODE_OPTIONS: Array<{ id: ModeOption; label: string }> = [
  { id: 'value', label: 'Value' },
  { id: 'percentage', label: 'Percentage' },
];

export interface ModeSelectorProps {
  disablePercentageMode: boolean;
  onChange: (mode: ModeOption) => void;
  value?: ModeOption;
}

export function ModeSelector({ disablePercentageMode, onChange, value = 'value' }: ModeSelectorProps) {
  const handleModeChange = (_: unknown, { id }: { id: ModeOption }) => {
    onChange(id);
  };

  return (
    <OptionsEditorControl
      label="Mode"
      control={
        <SettingsAutocomplete
          value={MODE_OPTIONS.find((o) => o.id === value)}
          options={MODE_OPTIONS}
          getOptionLabel={(o) => o.label}
          getOptionDisabled={(o) => o.id === 'percentage' && disablePercentageMode}
          onChange={handleModeChange}
          disableClearable
        />
      }
    />
  );
}
